import React, { createContext, useMemo, useState } from 'react';
import type { GenericsContextProps, IGenericsState } from '../types';

const INITIAL_STATE: IGenericsState = {
  isMobile: false,
};

export const GenericsContext = createContext<GenericsContextProps>({
  genericsState: INITIAL_STATE,
  updateGenericsState: {} as GenericsContextProps['updateGenericsState'],
});

const GenericsProvider = ({ children }: { children: React.ReactNode }) => {
  const [isMobile, setIsMobile] = useState<IGenericsState['isMobile']>(INITIAL_STATE.isMobile);

  const genericsState: IGenericsState = {
    isMobile,
  };

  const updateGenericsState: GenericsContextProps['updateGenericsState'] = {
    isMobile: (state: IGenericsState['isMobile']) => setIsMobile(state),
  };

  const props: GenericsContextProps = useMemo(() => ({ genericsState, updateGenericsState }), [isMobile]);

  return <GenericsContext.Provider value={props}>{children}</GenericsContext.Provider>;
};

export default GenericsProvider;
